module.exports = __webpack_public_path__ + "img/dashboard-landing-area-filter.f146b264.gif";